import { render, staticRenderFns } from "./VolunteerProfileAbout.vue?vue&type=template&id=028bfa5f&scoped=true"
import script from "./VolunteerProfileAbout.vue?vue&type=script&lang=js"
export * from "./VolunteerProfileAbout.vue?vue&type=script&lang=js"
import style0 from "./VolunteerProfileAbout.vue?vue&type=style&index=0&id=028bfa5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028bfa5f",
  null
  
)

export default component.exports